import { useEffect, useRef, useState } from "react";
import Veda from "vedajs";
import * as THREE from "three";
import useShaderManager from "./useShaderManager";
import useCanvasManager from "./useCanvasManager";

export function VedaWrapper() {
  const canvasRef = useRef();
  const vedaRef = useRef();
  const { checkpoint1 } = useShaderManager((state) => state);
  const { fragCode, yState } = useShaderManager((state) => state);
  const updateState = useShaderManager((state) => state.update);
  const { errors, addError } = useShaderManager((state) => state);
  const { doodleRef } = useCanvasManager((state) => state);
  useEffect(() => {
    if (canvasRef.current === null) return;

    const _veda = new Veda();

    // _veda.toggleCamera(true);
    // _veda.toggleAudio(true);

    updateState("vedaRef", _veda);
    _veda.setCanvas(canvasRef.current);
    vedaRef.current = _veda;

    evalFragment(checkpoint1);
  }, [canvasRef.current]);

  const evalFragment = (code) => {
    vedaRef.current.loadFragmentShader(code);
    vedaRef.current.play();
  };

  useEffect(() => {
    const resizeHandler = () => {
      if (!vedaRef.current) return;
      vedaRef.current.resize();
    };

    window.addEventListener("resize", resizeHandler);

    return () => window.removeEventListener("resize", resizeHandler);
  }, []);

  useEffect(() => {
    if (!yState) return;

    const keyHandler = (event) => {
      var name = event.key;
      var code = event.code;
      if (name === "Control") {
        // Do nothing.
        return;
      }
      if (event.ctrlKey) {
        if (name == "Enter") {
          yState.set("frag", true);
        }
      }
    };

    document.addEventListener("keydown", keyHandler, false);

    return () => window.removeEventListener("resize", keyHandler);
  }, [yState]);

  const checkFragmentShader = () => {
    if (!vedaRef.current) return;
    var gl = vedaRef.current.renderer.getContext();
    if (!gl) return;

    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(shader, fragCode);
    gl.compileShader(shader);

    let infoLog = gl.getShaderInfoLog(shader);
    let result = gl.getShaderParameter(shader, gl.COMPILE_STATUS);

    if (result) return [];

    const _errors = [];
    if (!result) {
      var errors = infoLog.split(/\r|\n/);
      for (let error of errors) {
        const _error = error.split(":");
        const line = _error[2];
        const character = _error[1];
        const message = _error[3] + _error[4];

        const validLine = Number.isInteger(parseInt(line));

        if (validLine)
          _errors.push({
            message,
            line,
            character,
          });
      }
    }
    return _errors;
  };

  useEffect(() => {
    if (fragCode.length === 0) return;

    const check = checkFragmentShader();
    const isValid = check.length === 0;

    if (isValid && vedaRef.current) {
      vedaRef.current.loadFragmentShader(fragCode);
    }

    if (errors.length === 0 && check.length > 0) {
      updateState("errors", check);
    }
    if (errors.length > 0 && isValid) {
      updateState("errors", []);
    }
  }, [fragCode, updateState, errors]);

  useEffect(() => {
    if (!doodleRef) return;
    console.log(doodleRef);
    vedaRef.current.uniforms["doodle"] = {
      type: "t",
      value: new THREE.Texture(doodleRef),
    };

    vedaRef.current.uniforms["doodle"].value.needsUpdate = true;
  }, [doodleRef]);

  return <canvas ref={canvasRef}></canvas>;
}
